//--------------------------------------------------
// imported classes
//--------------------------------------------------
const ClassFunc = require('@/tbs/util/ClassFunc')
const Referee = require('@/tbs/model/vo/Referee')

/**
 * The Referee class acts as the view object for the referee.
 */
const tbs_model_vo_RefereeInMatch = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Referee, arguments)
    // console.log('tbs_model_vo_RefereeInMatch constructor')
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_RefereeInMatch.prototype = {
    /* The view object name */
    name: 'referee',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetUnionMatchRefereeList',
            basePath: 'data.list',
            query: {
                unionMatchId: 'id',
            },
            rule: {
                id: 'refereeId',
                name: 'name',
                firstLetter: '$nameInitials',
                avatarUrl: 'avatar',
                phone: 'mobile',
                isInvited: '@userId',
                shiftTag: '$id',
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminCreateUnionMatchReferee',
            basePath: '',
            rule: {
                accountId: 'organizationId',
                unionMatchId: 'matchId',
                name: 'name',
                avatar: 'avatar',
                mobile: 'phone',
                refereeLevel: '$grade',
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminUpdateUnionMatchRefereeStatus',
            basePath: '',
            rule: {
                id: 'id',
                unionMatchId: 'matchId',
                status: '(-2)',
            }
        },
        load: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminGetCrmRefereeList',
            basePath: 'data.list',
            query: {
                accountId: 'organizationId',
                notInUnionMatchId: 'matchId',
                clientType: '(h5)',
            },
            rule: {
                id: '~id',
                label: 'name',
                subtext: 'refereeLevel',
            }
        },
        add: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'AdminCreateUnionMatchReferees',
            basePath: '',
            rule: {
                unionMatchId: 'matchId',
                ids: '$refereeList',
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    formatIds: function(refereeList) {
        return refereeList.join(',')
    },
    renderShiftTag: function() {
        return this.localeProp('shift')
    },
}

//--------------------------------------------------
// extends the Referee
//--------------------------------------------------
ClassFunc.extend(tbs_model_vo_RefereeInMatch, Referee);

module.exports = tbs_model_vo_RefereeInMatch